export const dataMentionAttribute = 'data-mention';
export const dataMentionUserIdAttribute = 'data-mention-user-id';

export function userMentionCustomisation(args: { editorInstance: any }) {
  const { editorInstance: editor } = args;

  editor.conversion.for('upcast').elementToAttribute({
    view: {
      name: 'span',
      classes: ['mention'],
    },
    model: {
      key: 'mention',
      value: (viewItem: any) => {
        // The mention feature expects that the mention attribute value
        // in the model is a plain object with a set of additional attributes.
        // In order to create a proper object use the toMentionAttribute() helper method:
        const mentionAttribute = editor.plugins.get('Mention').toMentionAttribute(viewItem, {
          // Add any other properties that you need.
          id: viewItem.getAttribute(dataMentionAttribute),
          uid: viewItem.getAttribute(dataMentionUserIdAttribute),
        });

        return mentionAttribute;
      },
    },
    converterPriority: 'high',
  });

  editor.conversion.for('downcast').attributeToElement({
    model: 'mention',
    view: (modelAttributeValue: any, { writer }: any) => {
      if (!modelAttributeValue) {
        return;
      }

      return writer.createAttributeElement('span', {
        class: 'mention',
        [dataMentionAttribute]: modelAttributeValue.id,
        [dataMentionUserIdAttribute]: modelAttributeValue.uid,
      });
    },
    converterPriority: 'high',
  });
}
